import { createFileRoute } from "@tanstack/react-router";

import { NovaArchive } from "~/components/nova/archive/nova-archive";

export const Route = createFileRoute(
  "/_user/my-coaching/business/nova/archive",
)({
  staticData: { title: "Past conversations" },
  component: NovaArchive,
});
